<template>
  <div class="user-card">
    <div
      v-if="userpic"
      class="user-card__visual"
    >
      <div class="userpic">
        <img
          :src="userpic"
          :alt="$t('Photo')"
        >
      </div>
    </div>
    <div class="user-card__info">
      <p>
        Hello, <strong>{{ username }}</strong>!
      </p>
      <p>{{ email }}</p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    username: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    userpic: {
      type: String,
    },
  },
})
export default class UserCard extends Vue {}
</script>
<style lang="scss" scoped>
.user-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  &__visual {
    flex-basis: 50px;
    & + * {
      margin-left: 10px;
    }
  }
  &__info {
    flex-grow: 1;
    min-width: 0; // hotfix for ellipsis
    p {
      margin: 0;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    p + p {
      margin-top: 0.2em;
    }
  }
}
</style>
